import { render, staticRenderFns } from "./autoPaymentForProprietor.vue?vue&type=template&id=3b09c570&scoped=true"
import script from "./autoPaymentForProprietor.vue?vue&type=script&lang=js"
export * from "./autoPaymentForProprietor.vue?vue&type=script&lang=js"
import style0 from "./autoPaymentForProprietor.vue?vue&type=style&index=0&id=3b09c570&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b09c570",
  null
  
)

export default component.exports